/* Promo + product-list tracking -> dataLayer (GA4 ecommerce format).
 * Reads only data attributes:
 *   [data-promo] / [data-promo-creative] / [data-promo-role]  (snippets/promo-attrs)
 *   [data-promo-for="id"]  a control (e.g. tab button) that counts as a click on #id
 *   [data-item-list] / [data-item-index] wrapping a product-block[data-product-id]
 * Never touches page behaviour: no preventDefault, no DOM writes besides data-* flags.
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var dl = (window.dataLayer = window.dataLayer || []);
  var MIN_VISIBLE = 0.5;
  var MIN_MS = 1000;

  function push(ev) { dl.push({ ecommerce: null, promo_role: null }); dl.push(ev); }   // reset so a view never shows the last click's role
  function fileName(url) { return (url || '').split('?')[0].split('/').pop(); }
  function slotOf(el) {
    var sec = el.closest('[id^="shopify-section-template--"]');
    if (!sec) return '';
    var all = document.querySelectorAll('[id^="shopify-section-template--"]');
    for (var i = 0; i < all.length; i++) if (all[i] === sec) return String(i + 1);
    return '';
  }
  function promoItem(el) {
    var name = el.getAttribute('data-promo') || '';
    return {
      promotion_id: name, promotion_name: name,
      creative_name: el.getAttribute('data-promo-creative') || '',
      creative_slot: slotOf(el), location_id: location.pathname
    };
  }
  function listItem(wrap) {
    var pb = wrap.querySelector('[data-product-id]');
    var title = wrap.querySelector('.product-block__title');
    var list = wrap.getAttribute('data-item-list') || '';
    return {
      item_id: pb ? pb.getAttribute('data-product-id') : '',
      item_name: title ? title.textContent.trim() : '',
      index: Number(wrap.getAttribute('data-item-index')) || 0,
      item_list_id: list, item_list_name: list
    };
  }

  /* ---------- impressions ---------- */
  var seenKeys = {};            // dedupes carousel clones: name|creative
  var timers = new WeakMap();
  var listBatch = {}, listTimer = null;

  function flushLists() {
    listTimer = null;
    Object.keys(listBatch).forEach(function (list) {
      // theme_ prefix so the GTM trigger ignores the Shopify channel's own view_item_list on collection pages; the GA4 tag renames it back
      push({ event: 'theme_view_item_list', ecommerce: { item_list_id: list, item_list_name: list, items: listBatch[list] } });
    });
    listBatch = {};
  }
  function fireView(el) {
    if (el.hasAttribute('data-item-list')) {
      var it = listItem(el);
      (listBatch[it.item_list_name] = listBatch[it.item_list_name] || []).push(it);
      if (!listTimer) listTimer = setTimeout(flushLists, 300);
      return;
    }
    var p = promoItem(el);
    var key = p.promotion_name + '|' + p.creative_name;
    if (seenKeys[key]) return;
    seenKeys[key] = true;
    push({ event: 'view_promotion', ecommerce: { creative_name: p.creative_name, creative_slot: p.creative_slot,
      promotion_id: p.promotion_id, promotion_name: p.promotion_name, location_id: p.location_id, items: [p] } });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (e.isIntersecting && e.intersectionRatio >= MIN_VISIBLE && !document.hidden) {
        if (timers.has(el)) return;
        timers.set(el, setTimeout(function () {
          timers.delete(el);
          if (el.getAttribute('data-promo-seen')) return;
          el.setAttribute('data-promo-seen', '1');
          io.unobserve(el);
          fireView(el);
        }, MIN_MS));
      } else if (timers.has(el)) {
        clearTimeout(timers.get(el)); timers.delete(el);
      }
    });
  }, { threshold: [MIN_VISIBLE] });

  function observe(root) {
    var nodes = root.querySelectorAll ? root.querySelectorAll('[data-promo]:not([data-promo-role="control"]),[data-item-list]') : [];
    for (var i = 0; i < nodes.length; i++) if (!nodes[i].getAttribute('data-promo-seen')) io.observe(nodes[i]);
    if (root.querySelectorAll) wireVideos(root);
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var ctl = t.closest('[data-promo-for]');
    var el = ctl ? document.getElementById(ctl.getAttribute('data-promo-for')) : t.closest('[data-promo],[data-item-list]');
    if (!el) return;
    if (el.hasAttribute('data-item-list')) {           // whole card counts, wishlist heart and swatches included
      var it = listItem(el);
      push({ event: 'select_item', ecommerce: { item_list_id: it.item_list_id, item_list_name: it.item_list_name, items: [it] } });
      return;
    }
    if (!ctl && t.closest('[data-promo-role="control"],button')) return;   // arrows, dots, pause
    var p = promoItem(el);
    var a = t.closest('a[href]');
    // promo_role: 'tab' for a control, 'button:<label>' for a link inside the promo, else the element's own data-promo-role (circle, video) or 'banner'
    var role = ctl ? 'tab' : (a && a !== el && el.contains(a)) ? 'button:' + a.textContent.replace(/\s+/g, ' ').trim() : (el.getAttribute('data-promo-role') || 'banner');
    push({ event: 'select_promotion', promo_role: role, ecommerce: { creative_name: p.creative_name, creative_slot: p.creative_slot,
      promotion_id: p.promotion_id, promotion_name: p.promotion_name, location_id: p.location_id, items: [p] } });
  }, true);

  /* ---------- video ---------- */
  function wireVideos(root) {
    var vids = root.querySelectorAll('[data-promo] video');
    for (var i = 0; i < vids.length; i++) (function (v) {
      if (v.getAttribute('data-promo-video')) return;
      v.setAttribute('data-promo-video', '1');
      var promo = v.closest('[data-promo]');
      var title = promo ? promo.getAttribute('data-promo') : '';
      var fired = {};
      function send(name, pct) {
        if (fired[name + pct]) return;
        fired[name + pct] = true;
        push({ event: name, video_title: title, video_url: fileName(v.currentSrc || v.src), video_percent: pct,
          video_duration: Math.round(v.duration || 0), video_current_time: Math.round(v.currentTime || 0) });
      }
      v.addEventListener('play', function () { send('video_start', 0); });
      v.addEventListener('timeupdate', function () {
        if (!v.duration) return;
        var pct = v.currentTime / v.duration * 100;
        [25, 50, 75].forEach(function (m) { if (pct >= m) send('video_progress', m); });
      });
      v.addEventListener('ended', function () { send('video_complete', 100); });
    })(vids[i]);
  }

  /* ---------- start after load so late images cannot shift elements through the viewport ---------- */
  // shortcut: elements inserted after load are not observed; add a MutationObserver if a promo ever loads asynchronously
  function start() { observe(document); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
